export function makeMenuConfigurations(s3ActionUrls, userPermissions) {
	const menu = [
		{
			title: 'Empresa',
			key: 'empresa',
			icon: 'fal fa-cog',
			submenu: [
				{
					label: 'Dados da Empresa',
					url: '/configuracoes/empresa/dados-empresa'
				},
				{
					label: 'Links dos Aplicativos',
					url: '/configuracoes/empresa/links-apps'
				},
				{
					label: 'Autenticação',
					url: '/configuracoes/empresa/autenticacao'
				}
			]
		},
		{
			title: 'Usuários',
			key: 'usuarios',
			icon: 'fal fa-user-circle',
			submenu: [
				{
					label: 'Novos Cadastros',
					url: '/configuracoes/usuarios/novos-cadastros'
				},
				{
					label: 'Grupos de Usuários',
					url: '/configuracoes/usuarios/grupos'
				},
				{
					label: 'Perfis Dinâmicos',
					url: '/configuracoes/usuarios/perfis-dinamicos'
				}
			]
		},
		{
			title: 'Arquivos',
			key: 'arquivos',
			icon: 'fal fa-file-alt',
			submenu: [
				{
					label: 'Tipos de Arquivos',
					url: '/configuracoes/arquivos/tipos-de-arquivos'
				},
				{
					label: 'Limites de Armazenamento',
					url: '/configuracoes/arquivos/limites-de-armazenamento'
				}
			]
		},
		{
			title: 'Clientes',
			key: 'clientes',
			icon: 'fal fa-user-cog',
			submenu: [
				{
					label: 'Configurações Gerais',
					url: '/configuracoes/clientes/geral'
				},
				{
					label: 'Permissões',
					url: '/configuracoes/clientes/permissoes'
				},
				{
					label: 'Data de Venda',
					url: '/configuracoes/clientes/data-venda'
				},
				{
					label: 'Origens de Atendimento',
					url: '/configuracoes/clientes/origens-de-atendimento'
				},
				{
					label: 'Gerenciar Canais',
					url: '/configuracoes/clientes/canais'
				},
				{
					label: 'Gerenciar Origens',
					url: '/configuracoes/clientes/origens'
				},
				{
					label: 'Regras de Ociosidade',
					url: '/configuracoes/clientes/regras-de-ociosidade'
				},
				{
					label: 'Campos Obrigatórios',
					url: '/configuracoes/clientes/campos-obrigatorios'
				},
				{
					label: 'Duplicidade',
					url: '/configuracoes/clientes/duplicidade'
				}
			]
		},
		{
			title: 'Clube de Pontos',
			key: 'clube',
			icon: 'fal fa-trophy-alt',
			submenu: [
				{
					label: 'Configurações Gerais',
					url: '/configuracoes/clube/geral'
				},
				{
					label: 'Permissões',
					url: '/configuracoes/clube/permissoes'
				}
			]
		},
		{
			title: 'Funil de Vendas',
			key: 'funil-de-vendas',
			icon: 'fal fa-filter',
			submenu: [
				{
					label: 'Configurações Gerais',
					url: '/configuracoes/funil-de-vendas/geral'
				},
				{
					label: 'Call Tracking',
					url: '/configuracoes/funil-de-vendas/call-tracking'
				},
				{
					label: 'Etapas e Status',
					url: '/configuracoes/funil-de-vendas/etapa-status'
				},
				{
					label: 'Ações do Funil',
					url: '/configuracoes/funil-de-vendas/acoes-do-funil'
				},

				{
					label: 'Permissões',
					url: '/configuracoes/funil-de-vendas/permissoes'
				},
			]
		},
		{
			title: 'Reservas',
			key: 'reservas',
			icon: 'fal fa-map-marker-alt',
			submenu: [
				{
					label: 'Permissões',
					url: '/configuracoes/reservas/permissoes'
				},
				{
					label: 'Campos Obrigatórios',
					url: '/configuracoes/reservas/campos-obrigatorios'
				},
				{
					label: 'Duplicidade',
					url: '/configuracoes/reservas/duplicidade'
				},
                // Apenas adiciona "Gestão Profissional" se userPermissions existir
                ...(userPermissions ? [{
                    label: 'Configurações Avançadas',
                    url: '/configuracoes/reservas/configuracoes-avancadas'
                }] : [])
			]
		},
		{
			title: 'Propostas',
			key: 'propostas',
			icon: 'fal fa-file-certificate',
			submenu: [
				{
					label: 'Campos Obrigatórios',
					url: '/configuracoes/propostas/campos-obrigatorios'
				},
				{
					label: 'Duplicidade',
					url: '/configuracoes/propostas/duplicidade'
				},
				{
					label: 'Campos da Proposta',
					url: '/configuracoes/propostas/campos-proposta'
				},
				{
					label: 'Preencher Proposta',
					url: '/configuracoes/propostas/preencher-proposta'
				},
				{
					label: 'Campos de Pagamento',
					url: '/configuracoes/propostas/campos-de-pagamento'
				},
				{
					label: 'Simulador de Propostas',
					url: '/configuracoes/propostas/simulador-de-propostas'
				},
				{
					label: 'Gerar Contratos',
					url: '/configuracoes/propostas/gerar-contratos'
				},
				{
					label: 'Tabela de Vendas',
					url: '/configuracoes/propostas/tabela-de-vendas'
				},
				{
					label: 'Séries',
					url: '/configuracoes/propostas/series'
				}
			]
		},
		{
			title: 'Negócios',
			key: 'negocios',
			icon: 'fal fa-handshake',
			submenu: [
				{
					label: 'Configurações Gerais',
					url: '/configuracoes/negocios/configuracoes-gerais'
        },
      	{
					label: 'Permissões',
					url: '/configuracoes/negocios/permissoes'
				},
			]
		},
	]

	// Concatenação para garantir como o último item do menu
	const advancedConfig = [{
		title: 'Configurações Avançadas',
		key: 'avancado',
		icon: '',
		submenu: [
			...generateAdvancedSubmenu(s3ActionUrls),
			{ 
				label: 'Depuração do envio de propostas', 
				url: '/configuracoes/avancado/modo-debuger' 
			},
		]
	}]

	return [ ...menu, ...advancedConfig ]
}

const generateAdvancedSubmenu = function(s3ActionUrls) {
	return s3ActionUrls.map(action => ({
		label: action.title,
		url: `/configuracoes/avancado/acoes/${action.id}`,
		iframe_url: action.url
	}))
}